import { isReadOnly } from 'customer-data-objects/property/PropertyIdentifier';
import { AMOUNT, MARGIN, NAME, TERM, SKU, DISCOUNT, PRICE, QUANTITY, RECURRING_BILLING_FREQUENCY, UNIT_COST, ARR, MRR, ACV, TCV, ARR_MARGIN, MRR_MARGIN, ACV_MARGIN, TCV_MARGIN, TERM_IN_MONTHS, PRE_DISCOUNT_AMOUNT, TOTAL_DISCOUNT, BILLING_TERMS, NUM_PAYMENTS, START_DATE, BILLING_START_DELAY_MONTHS, BILLING_START_DELAY_DAYS } from 'customer-data-objects/lineItem/PropertyNames';
import { DATE, DATE_TIME, ENUMERATION, NUMBER } from 'customer-data-objects/property/PropertyTypes';
import { CHECKBOX } from 'customer-data-objects/property/PropertyFieldTypes';
const INPUT_CELL_PROPERTY_NAMES = [NAME, TERM, BILLING_TERMS, NUM_PAYMENTS];
// TEXT inputs are intentionally excluded below due to UI issues with spacing and content overflow
const INPUT_CELL_PROPERTY_TYPES = [DATE, DATE_TIME, ENUMERATION, NUMBER];
export const OEM_CALCULATION_PROPERTY_NAMES = [TERM_IN_MONTHS, AMOUNT, MARGIN, ARR, MRR, ACV, TCV, ARR_MARGIN, MRR_MARGIN, ACV_MARGIN, TCV_MARGIN, PRE_DISCOUNT_AMOUNT, TOTAL_DISCOUNT, 'hs_recurring_billing_terms', 'hs_tax_amount', 'hs_post_tax_amount'];

/**
 * Returns whether a given property should render as an input cell in LineItemEditorTable.
 * Input cells render LineItemInputCell in customer-data-table, otherwise we render
 * a standard read-only propertyColumn.
 *
 * We render inputs for all date, enums, and number properties, and for a few specific
 * properties by name.
 *
 * @param {PropertyRecord} property - The property to check for input
 * @return {Boolean} - True if property should render as input cell
 */
export function shouldRenderInputCell(property = {}) {
  const isInputtable = INPUT_CELL_PROPERTY_NAMES.includes(property.name);
  const isInputtableType = !isReadOnly(property) && INPUT_CELL_PROPERTY_TYPES.includes(property.type);
  return isInputtable || isInputtableType;
}
export function isCalculationDependency(propertyName) {
  return [DISCOUNT, PRICE, QUANTITY, RECURRING_BILLING_FREQUENCY, TERM, UNIT_COST, 'hs_tax_rate'].includes(propertyName);
}

/**
 * @param {PropertyRecord} property - Property whose cell width to calculate
 * @return {number} - Cell width for given property
 */
export function getDefaultColumnWidth(property = {}) {
  if (property.name === NAME) {
    return 300;
  }
  if (property.name === DISCOUNT) {
    return 250;
  }
  if (property.name === SKU) {
    return 125;
  }
  if (property.name === TERM) {
    return 165;
  }
  if (property.name === BILLING_TERMS) {
    return 375;
  }
  if (property.name === START_DATE) {
    return 300;
  }
  if (property.name === BILLING_START_DELAY_DAYS) {
    return 250;
  }
  if (property.name === BILLING_START_DELAY_MONTHS) {
    return 275;
  }
  if (property.name === RECURRING_BILLING_FREQUENCY) {
    return 300;
  }
  if (property.name === 'hs_tax_rate_group_id' || property.name === 'hs_tax_category') {
    return 350;
  }
  switch (property.type) {
    case ENUMERATION:
      // Expand for multi-checkboxes only
      return property.fieldType === CHECKBOX ? 400 : 175;
    case NUMBER:
      return !isReadOnly(property) && property.showCurrencySymbol ? 175 : 125;
    case DATE:
      return 190;
    default:
      return 250;
  }
}
export function getColumnMinResizeWidth(propertyName) {
  if (propertyName === START_DATE) {
    return 250;
  }
  if (propertyName === BILLING_START_DELAY_DAYS) {
    return 225;
  }
  if (propertyName === BILLING_START_DELAY_MONTHS) {
    return 250;
  }
  return undefined;
}